// R12/R13 runtime flag bridge.
//
// The client bundle cannot read `process.env.COVERME_*` because webpack's
// DefinePlugin only inlines a curated allowlist (NODE_ENV, NEW_RELIC_*, and
// DS_IFRAME_TOKEN). Every other `process.env.X` compiles as
// `process.env.X` and resolves against the `process/browser.js` polyfill,
// whose `.env` is an empty object. Result: setting the env var on the pod
// has zero effect on the browser code path.
//
// Fix: the server-side booking controller emits
// `<script>window.__COVERME_FLAGS__ = {...}</script>` in the rendered HTML.
// This helper prefers that runtime bridge and falls back to `process.env`
// for Node/SSR code paths and unit tests (which set the env var directly
// via `process.env.COVERME_* = 'on'`).

export interface CovermeFlags {
  r12KeepaliveBeacon: boolean;
  r13QuoteDebounce: boolean;
}

const ENV_KEY_BY_FLAG: Record<keyof CovermeFlags, string> = {
  r12KeepaliveBeacon: 'COVERME_R12_KEEPALIVE_BEACON',
  r13QuoteDebounce: 'COVERME_R13_QUOTE_DEBOUNCE'
};

declare global {
  interface Window {
    __COVERME_FLAGS__?: Partial<CovermeFlags>;
  }
}

export const getCovermeFlag = (key: keyof CovermeFlags): boolean => {
  if (typeof window !== 'undefined' && window.__COVERME_FLAGS__) {
    const value = window.__COVERME_FLAGS__[key];
    if (typeof value === 'boolean') {
      return value;
    }
  }
  // Group 3 master COVERME_NETWORK_DEFERRAL enables both R12 + R13 together.
  return (
    process.env[ENV_KEY_BY_FLAG[key]] === 'on' ||
    process.env.COVERME_NETWORK_DEFERRAL === 'on'
  );
};
